import {
  useCallback,
  useEffect,
  useRef,
  useState,
  type MutableRefObject,
  type CSSProperties,
} from 'react';
import { useMousePosition } from '~/hooks';

export interface StickyPopoverHook {
  ref: MutableRefObject<HTMLDivElement | undefined>;
  showPopover: boolean;
  popoverStyle: CSSProperties;
}

export default function useStickyPopover(): StickyPopoverHook {
  const ref = useRef<HTMLDivElement>();
  const [showPopover, setShowPopover] = useState(false);
  const { x, y } = useMousePosition(ref as MutableRefObject<HTMLElement>);

  const handleMouseEnter = useCallback(() => {
    setShowPopover(true);
  }, [setShowPopover]);

  const handleMouseLeave = useCallback(() => {
    setShowPopover(false);
  }, [setShowPopover]);

  useEffect(() => {
    if (ref.current) {
      ref.current.addEventListener('mouseenter', handleMouseEnter);
      ref.current.addEventListener('mouseleave', handleMouseLeave);
      return () => {
        if (ref.current) {
          ref.current.removeEventListener('mouseenter', handleMouseEnter);
          ref.current.removeEventListener('mouseleave', handleMouseLeave);
        }
      };
    }

    return () => {};
  }, [ref]);

  const popoverStyle: CSSProperties = {
    left: `${x}px`,
    top: `${y}px`,
  };

  return {
    ref,
    showPopover,
    popoverStyle,
  };
}
